var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventEmitter } from 'events';
/**
 * Minimal authentication scaffold used by the front-end.  It is intentionally
 * lightweight so we can drop in a real implementation later without changing
 * call sites.  For now it exposes a subscription API and a couple of stubbed
 * flows that simulate asynchronous login/logout requests.
 */
export class AuthScaffold {
    constructor() {
        this.emitter = new EventEmitter();
        this.state = { status: 'anonymous' };
        this.pendingTimer = null;
    }
    getState() {
        return Object.assign({}, this.state);
    }
    subscribe(eventName, listener) {
        this.emitter.on(eventName, listener);
        return () => this.emitter.off(eventName, listener);
    }
    beginLogin(playerName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.transition({ status: 'authenticating', playerName });
            this.clearPendingTimer();
            this.pendingTimer = setTimeout(() => {
                const fakeToken = `debug-token-${Date.now().toString(36)}`;
                this.transition({
                    status: 'authenticated',
                    playerName,
                    token: fakeToken,
                    expiresAt: Date.now() + 60 * 60 * 1000,
                });
            }, 400);
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearPendingTimer();
            const playerName = this.state.playerName;
            this.transition({ status: 'anonymous', playerName });
        });
    }
    refreshToken(token) {
        if (!token || this.state.status !== 'authenticated')
            return;
        this.transition(Object.assign(Object.assign({}, this.state), { token, expiresAt: Date.now() + 60 * 60 * 1000 }));
    }
    transition(next) {
        this.state = Object.assign({}, next);
        this.emitter.emit('statechange', this.getState());
        if (next.status === 'authenticated' && next.expiresAt) {
            this.scheduleExpiry(next.expiresAt);
        }
    }
    scheduleExpiry(expiresAt) {
        const ms = Math.max(0, expiresAt - Date.now());
        this.clearPendingTimer();
        this.pendingTimer = setTimeout(() => {
            this.pendingTimer = null;
            this.emitter.emit('tokenexpired', undefined);
        }, ms);
    }
    clearPendingTimer() {
        if (this.pendingTimer !== null) {
            clearTimeout(this.pendingTimer);
            this.pendingTimer = null;
        }
    }
}
